import { Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AButton } from 'views/components/Analytics'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { SharedModalContent, SharedModalTitle } from 'views/components/SharedModal/styled'
import { AnalyticsPlaces } from '../../analyticsPlaces'

type Props = {
  id: string
}

export const DeletePotentialButton: FC<Props> = ({ id }) => {
  const { t } = useTranslation('bid')
  const navigate = useNavigate()
  const notify = useNotification()
  const [isConfirmVisible, setConfirmVisible] = useState<boolean>(false)
  const [deleteBidProgress, deleteBid] = useAProgress(() => apiClient.delete(endpoints.potentialBid(id)), {
    eventName: 'delete',
    onSuccess: () => {
      setConfirmVisible(false)
      navigate(-1)
      notify(Progress.SUCCESS, { title: t('potentialDeleteSuccess') })
    },
  })

  return (
    <>
      <AButton color="destruct" size="medium" onClick={() => setConfirmVisible(true)} id="delete">
        {t('common:delete')}
      </AButton>

      {isConfirmVisible && (
        <ASharedModal onClose={() => setConfirmVisible(false)} size="small" id={AnalyticsPlaces.DELETE_MODAL}>
          <SharedModalTitle>{t('deletePotential')}</SharedModalTitle>
          <SharedModalContent>{t('areYouSureToDeletePotential')}</SharedModalContent>
          <ADefaultModalFooter
            onConfirm={deleteBid}
            confirmButtonText={t('common:delete')}
            progress={deleteBidProgress}
            onClose={() => setConfirmVisible(false)}
          />
        </ASharedModal>
      )}
    </>
  )
}
